import { useState } from "react";
import { useParams, useOutletContext } from "react-router-dom";
import { Mail } from "lucide-react";
import ProjectMembersPanel from "@/components/ProjectMembersPanel";
import MessageMembersDialog from "@/components/MessageMembersDialog";
import PendingInvitesSection from "@/components/PendingInvitesSection";
import { useAuth } from "@/lib/auth";

export default function ProjectMembersPage() {
  const { id } = useParams();
  const { project } = useOutletContext();
  const { user: me } = useAuth();
  const [messageOpen, setMessageOpen] = useState(false);

  // Project-editor+ (or project-admin) can message members. Global admins also qualify.
  const role = project?.my_role;
  const canMessage = role === "admin" || role === "editor";
  // Only global admins can see + manage pending invites (matches backend gate).
  const isGlobalAdmin = me?.role === "admin";

  return (
    <div className="max-w-screen-2xl mx-auto px-6 lg:px-10 py-8 space-y-6">
      {canMessage && (
        <div className="flex items-center justify-end">
          <button
            data-testid="open-message-members-btn"
            onClick={() => setMessageOpen(true)}
            className="inline-flex items-center gap-2 px-4 py-2 text-sm font-semibold bg-amber-500 text-black hover:bg-amber-400 rounded-sm transition-colors"
          >
            <Mail className="w-4 h-4" /> Message Members
          </button>
        </div>
      )}

      {isGlobalAdmin && (
        <PendingInvitesSection
          projectId={id}
          title="Pending Invites — this project"
        />
      )}

      <ProjectMembersPanel projectId={id} myRole={role} />

      <MessageMembersDialog
        open={messageOpen}
        onOpenChange={setMessageOpen}
        projectId={id}
        projectName={project?.name}
      />
    </div>
  );
}
